import { render, staticRenderFns } from "./OperationFlagsCard.vue?vue&type=template&id=7f30d054&scoped=true"
import script from "./OperationFlagsCard.vue?vue&type=script&lang=js"
export * from "./OperationFlagsCard.vue?vue&type=script&lang=js"
import style0 from "./OperationFlagsCard.vue?vue&type=style&index=0&id=7f30d054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f30d054",
  null
  
)

export default component.exports